
import React from 'react'
import { Form, Formik } from 'formik'
import { object, string } from "yup"
import FieldEmail from '../../lib/components/FormFields/FieldEmail'
import PasswordSubmitButton from './PasswordSubmitButton'

const PasswordForm  = ({
    onSubmitForm
}) => {
    const initData = {
        email: ''
    }

    const validationSchema = object({
        email: string().required('Bitte geben sie ihre Email an.')
    }).required().noUnknown()

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initData}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
                onSubmitForm(values)
                setSubmitting(false)
            }}
        >
            {({ errors, dirty, isSubmitting }) => (
                <Form className="jm-form jm-pwd-form">
                    <div className="jm-content-light">
                        <FieldEmail
                            id='email'
                            displayName='Email'
                            classNamePrefix='jm-pwd-form'
                            placeholder="Email"
                        />
                    </div>
                
                    <PasswordSubmitButton
                        dirty={dirty}
                        errors={errors}
                        disabled={isSubmitting}
                    />
                </Form>
            )}
        </Formik>
    )

}

export default PasswordForm